export const questionnaire = {
  "questionnaire_title": "Cuestionarios",
  "questionnaire_point": "puntos",
  "questionnaire_questionnaire": "Preguntas",
  "questionnaire_minutes": "minutos",
  "questionnaire_continue": "Continuar",
  "questionnaire_start": "Comenzar"
}
